function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h240v240H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  fillRule: "nonzero",
  d: "M64 52h3v62h-3zm105 0h3v46h-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  d: "M64 52h108v3H64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.127 76.38l-26.22 19.665m56.908-42.57l20.831-15.548 20.996 15.175m33.111 23.933l26.093 18.855M39.44 202.217v-103.9L116.72 173l79.509-74.898.002 104.115z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.308 104.168c-1.519-.714-2.816-1.601-3.89-2.663l-.3-.298.235-.352 1.631-2.433a2.19 2.19 0 01.74-.687 1.97 1.97 0 01.995-.273c.419 0 .846.14 1.28.41.361.226.773.49 1.234.794.442.29.949.583 1.52.877.403.207.866.375 1.39.503l.731-8.653a33.65 33.65 0 01-2.657-.91 10.616 10.616 0 01-2.819-1.619c-.853-.686-1.54-1.552-2.06-2.593-.524-1.054-.783-2.352-.783-3.891 0-1.16.232-2.294.695-3.397a9.022 9.022 0 012.013-2.956c.876-.865 1.952-1.574 3.225-2.13 1.159-.506 2.466-.812 3.92-.92l.198-2.27c.038-.464.232-.881.567-1.237.358-.378.83-.57 1.38-.57h2.512l-.373 4.333c1.378.263 2.589.685 3.63 1.268a14.847 14.847 0 012.98 2.165l.31.296-.236.358-1.296 1.972c-.231.331-.47.588-.723.77-.29.208-.638.31-1.027.31-.298 0-.622-.087-.977-.252-.3-.14-.642-.307-1.027-.504-.37-.189-.78-.382-1.229-.58a7.495 7.495 0 00-.861-.313l-.666 7.899a51.37 51.37 0 012.696.932c1.053.397 2.004.912 2.852 1.544a7.585 7.585 0 012.106 2.412c.547.98.817 2.189.817 3.621a11 11 0 01-.7 3.94 9.707 9.707 0 01-2.05 3.273c-.899.947-2.002 1.714-3.307 2.301-1.187.534-2.523.873-4.008 1.019l-.223 2.736c-.038.448-.23.858-.563 1.219-.357.388-.83.585-1.385.585h-2.51l.393-4.687a16.593 16.593 0 01-4.38-1.35zm11.655-5.33c.686-.725 1.03-1.679 1.03-2.888 0-.474-.081-.876-.24-1.214a2.909 2.909 0 00-.696-.925 4.774 4.774 0 00-1.116-.739 11.29 11.29 0 00-.869-.378l-.62 7.422c1.094-.23 1.927-.659 2.511-1.277zm-6.29-19.874c-.503.214-.909.47-1.219.77a2.696 2.696 0 00-.661.969 3.17 3.17 0 00-.213 1.16c0 .476.08.886.235 1.233.159.356.382.672.67.95.304.29.664.551 1.084.781.254.14.523.271.806.395l.554-6.627a6.312 6.312 0 00-1.256.369z",
  fill: "#81C784"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84 123.5h66.54m-60.54 9h54.676m-42.08 9h30.315",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -363.901 179.507)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -358.901 198.167)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -353.901 216.828)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -348.901 235.488)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -343.901 254.148)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -338.901 272.808)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -333.901 291.469)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -328.901 310.129)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -323.901 328.79)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -318.901 347.45)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -313.901 366.11)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -308.901 384.77)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -303.901 403.43)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -298.901 422.09)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -293.901 440.75)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -288.901 459.41)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 17.866,
  r: 1
})));

function SvgBillPaymentsXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBillPaymentsXl;